var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFinancialHigh6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115,
    height: 115,
    viewBox: "0 0 115 115",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.311 54.718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.792,33.9a57.5,57.5,0,1,1-57.5-57.5,57.5,57.5,0,0,1,57.5,57.5",
    transform: "translate(58.519 -31.114)",
    fill: "#2d9f52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.051,2.357H-24.812A1.971,1.971,0,0,1-26.771.369a1.971,1.971,0,0,1,1.959-1.987H38.051A1.973,1.973,0,0,1,40.009.369a1.973,1.973,0,0,1-1.959,1.987",
    transform: "translate(62.191 31.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2,18.555,12.143.577-9.208,12.942l-12.212-24.8,1.786-.877L-8.363,10.156,12.43-1.882,32.568,17.111Z",
    transform: "translate(63.905 -9.901)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.238,1.577h1.987V-36.138H24.238Z",
    transform: "translate(18.56 26.497)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.877-8.509h1.987v-20.7H26.877Z",
    transform: "translate(22.348 36.51)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.516-9.44H31.5V-28.575H29.516Z",
    transform: "translate(26.137 37.436)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.154-6.1h1.985V-30.871H32.154Z",
    transform: "translate(29.924 34.112)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.792-3.685h1.987V-32.526H34.792Z",
    transform: "translate(33.712 31.717)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.431-1.822h1.987V-33.805H37.431Z",
    transform: "translate(37.5 29.868)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.07-5.822h1.987V-31.059H40.07Z",
    transform: "translate(41.289 33.84)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.709-13.112h1.985V-26.054H42.709Z",
    transform: "translate(45.078 41.088)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.346-14.811h1.985V-24.888H45.346Z",
    transform: "translate(48.864 42.778)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.686,5.372h0A4.544,4.544,0,0,1-1.844.842a4.544,4.544,0,0,1,4.53-4.53A4.544,4.544,0,0,1,7.216.842a4.544,4.544,0,0,1-4.53,4.53",
    transform: "translate(41.303 -22.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.862,7.728A6.523,6.523,0,0,1-2.651,1.21a6.515,6.515,0,0,1,13.03,0A6.525,6.525,0,0,1,3.862,7.728m0-9.058A2.541,2.541,0,1,0,6.4,1.21,2.541,2.541,0,0,0,3.862-1.33",
    transform: "translate(40.134 -22.922)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.686,5.371h0A4.544,4.544,0,0,1-1.844.841a4.53,4.53,0,0,1,9.06,0,4.544,4.544,0,0,1-4.53,4.53",
    transform: "translate(52.523 0.383)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.865,7.729A6.525,6.525,0,0,1-2.653,1.212a6.518,6.518,0,0,1,13.035,0A6.525,6.525,0,0,1,3.865,7.729m0-9.06A2.543,2.543,0,1,0,6.407,1.212,2.548,2.548,0,0,0,3.865-1.331",
    transform: "translate(51.35 0.013)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.686,5.371h0A4.542,4.542,0,0,1-1.844.841a4.53,4.53,0,0,1,9.06,0,4.542,4.542,0,0,1-4.53,4.53",
    transform: "translate(73.543 -10.929)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.865,7.729A6.525,6.525,0,0,1-2.653,1.212a6.518,6.518,0,0,1,13.035,0A6.525,6.525,0,0,1,3.865,7.729m0-9.06A2.543,2.543,0,1,0,6.407,1.212,2.548,2.548,0,0,0,3.865-1.331",
    transform: "translate(72.361 -11.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.1,4.186l1.978-7.06L7.97,3.351,9.864,9.579,3.523,8.1-2.815,6.628Z",
    transform: "translate(89.795 2.066)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinancialHigh6);
export default __webpack_public_path__ + "static/media/financial-high-6.779002d1e20d9e11f5a6203ba26ef7bc.svg";
export { ForwardRef as ReactComponent };